export default {
    path: '/quality',
    name: 'Quality',
    component: () => import('@/layout/index.vue'),
    redirect: {
        name: 'QualityInspectionEntry',
    },
    meta: {
        title: '质量',
        icon: 'iconfont icon-jiancaixuangou',
        role: 'BACK_MENU2'
    },
    children: [{
            path: '/qualityInspectionEntry',
            name: 'QualityInspectionEntry',
            meta: {
                title: '质检录入',
                icon: 'el-icon-menu',
                role: 'BACK_MENU2_M1'
            },
            component: () => import('@/views/Quality/QualityInspectionEntry.vue'),
        },
        {
            path: '/qualityWhInventory',
            name: 'QualityWhInventory',
            meta: {
                title: "库存",
                icon: 'el-icon-menu',
                role: 'BACK_MENU2_M2'
            },
            component: () => import('@/views/Quality/QualityWhInventory.vue')
        },
        {
            path: '/qualityUnpackingPackage',
            name: 'QualityUnpackingPackage',
            meta: {
                title: "拆包",
                icon: 'el-icon-menu',
                role: 'BACK_MENU2_M3'
            },
            component: () => import('@/views/Quality/QualityUnpackingPackage.vue')
        },
        {
            path: '/locationAdjustment',
            name: 'LocationAdjustment',
            meta: {
                title: '物料移库',
                icon: 'el-icon-menu',
                role: 'BACK_MENU2_M4'
            },
            component: () => import('@/views/RawMaterialWarehouse/LocationAdjustment.vue'),
        },
        {
            path: '/QualityFreeze',
            name: 'QualityFreeze',
            meta: {
                title: '物料状态转换',
                icon: 'el-icon-menu',
                role: 'BACK_MENU2_M8'
            },
            component: () => import('@/views/Quality/QualityFreeze.vue'),
        },
        {
            path: '/stockCheck',
            name: 'StockCheck',
            meta: {
                title: "库品质检",
                icon: 'el-icon-menu',
                role: 'BACK_MENU2_M5'
            },
            component: () => import('@/views/Quality/stockCheck.vue')
        },
        {
            path: '/qualityReport',
            name: 'QualityReport',
            meta: {
                title: "质量报表",
                icon: 'el-icon-menu',
                role: 'BACK_MENU2_M6'
            },
            component: () => import('@/views/Quality/qualityReport.vue')
        },
        {
            path: '/QualityRecords',
            name: 'QualityRecords',
            meta: {
                title: "质量交易记录",
                icon: 'el-icon-menu',
                role: 'BACK_MENU2_M7'
            },
            component: () => import('@/views/Quality/QualityRecords.vue')
        },
    ],
}